export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "crop_field": {
            "self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campo"])},
            "organization_crop_field": {
              "crop_field_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])}
            },
            "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre"])},
            "hectares": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Área(Ha)"])},
            "square_meters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Área(m²)"])},
            "latitude_dd": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Coordenada Y"])},
            "longitude_dd": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Coordenada X"])},
            "latitude_dms": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Coordenada Y (º ' \")"])},
            "longitude_dms": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Coordenada X (º ' \")"])},
            "altitude": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Altitud"])},
            "location": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ubicación (localidad/zona/sector)"])},
            "planting_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de plantación/siembra"])},
            "harvest_time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Epoca de cosecha"])},
            "tree_number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número de plantas"])},
            "crop_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cultivo"])},
            "crop_variety_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Variedad"])},
            "crop_field_type_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo"])}
          }
        }
      },
      "en": {
        "model": {
          "crop_field": {
            "self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Field"])},
            "crop_field_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code"])},
            "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
            "hectares": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Area(Ha)"])},
            "square_meters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Area(m²)"])},
            "latitude": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Coordenada Y"])},
            "longitude": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Coordenada X"])}
          }
        }
      }
    }
  })
}